import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
// Helper service to synchronize scene creation events
@Injectable()
export class ThreadsyncService {
    public static syncDone = false;

    public setSync(flag) {
        ThreadsyncService.syncDone = flag;
    }

    public syncIsTrue() {
        return ThreadsyncService.syncDone === true;
    }

    public syncDone() {
        const poll = resolve => {
            // console.log('poll thread');
            if (this.syncIsTrue()) {
                // console.log('poll respond ready');
                resolve();
            } else {
                // console.log('poll respond not ready');
                setTimeout(_ => poll(resolve), 1000);
            }
        }
        return new Promise(poll);
    }
}